export default "__VITE_ASSET__LAqrAeMp__"